import axios from "axios";

export default {
  newSpis(spis_val, access_token, predmet_id, logged_uid) {
    try {
      return axios.post("https://app-psod.cratis.cloud/predmeti/" + predmet_id + "/spis", {
        params: {
          spis_val,
          access_token,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  getSingleSpis(access_token, predmet_id, spis_id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/predmeti/" + predmet_id + "/spis/" + spis_id, {
        params: {
          access_token
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateSingleSpis(predmet_id, spis_id, spis_val, logged_uid) {
    try {
      return axios.put("https://app-psod.cratis.cloud/predmeti/" + predmet_id + "/spis/" + spis_id, {
        params: {
          spis_val,
          logged_uid
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
};
